import { Check } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { SHRINE_IMAGE, LOGO_URL } from "../assets/images";

export default function Spirituality() {
  const { t } = useLang();
  const s = t.spirituality;

  return (
    <div data-testid="spirituality-page">
      {/* HERO */}
      <section className="container-page pt-20 sm:pt-28 pb-12">
        <div className="max-w-3xl">
          <div className="overline">{s.overline}</div>
          <h1 className="display-heading text-5xl sm:text-6xl mt-5 leading-[1.05]">
            {s.title}
          </h1>
          <span className="accent-rule mt-8 block" />
          <p className="mt-8 text-lg leading-relaxed text-[hsl(var(--muted-foreground))]">
            {s.lead}
          </p>
        </div>
      </section>

      {/* SHRINE */}
      <section className="container-page py-16 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-6">
          <img
            src={SHRINE_IMAGE}
            alt="Santuário de Schoenstatt"
            className="w-full h-[520px] object-cover"
          />
        </div>
        <div className="lg:col-span-6">
          <div className="overline">{s.shrineTitle}</div>
          <h2 className="display-heading text-3xl sm:text-4xl mt-4">
            {s.shrineTitle}
          </h2>
          <span className="accent-rule mt-6 block" />
          <p className="mt-6 text-[hsl(var(--muted-foreground))] leading-relaxed">
            {s.shrineBody}
          </p>
        </div>
      </section>

      {/* COVENANT + PEDAGOGY */}
      <section className="bg-[hsl(var(--secondary))] py-24">
        <div className="container-page grid lg:grid-cols-2 gap-12 lg:gap-20">
          <div className="bg-white border border-[hsl(var(--border))] p-8 sm:p-10">
            <div className="overline">{s.covenantTitle}</div>
            <h3 className="display-heading text-3xl mt-4">{s.covenantTitle}</h3>
            <span className="accent-rule mt-6 block" />
            <p className="mt-6 text-[hsl(var(--muted-foreground))] leading-relaxed">
              {s.covenantBody}
            </p>
          </div>
          <div className="bg-white border border-[hsl(var(--border))] p-8 sm:p-10">
            <div className="overline">{s.pedagogyTitle}</div>
            <h3 className="display-heading text-3xl mt-4">{s.pedagogyTitle}</h3>
            <span className="accent-rule mt-6 block" />
            <p className="mt-6 text-[hsl(var(--muted-foreground))] leading-relaxed">
              {s.pedagogyBody}
            </p>
          </div>
        </div>
      </section>

      {/* ITINERARIES — what we propose */}
      <section className="bg-[hsl(var(--primary))] text-white py-24 sm:py-32 relative overflow-hidden">
        <div className="absolute inset-0 grain pointer-events-none" />
        <div className="container-page relative grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <img src={LOGO_URL} alt="CIEES" className="h-14 opacity-90" />
            <div className="overline text-white/70 mt-8">{s.itinerariesTitle}</div>
            <h2 className="display-heading text-4xl sm:text-5xl mt-4 leading-[1.1]">
              {s.itinerariesTitle}
            </h2>
            <span className="accent-rule mt-6 block" />
          </div>
          <div className="lg:col-span-7">
            <p className="text-lg leading-relaxed text-white/85">{s.itinerariesBody}</p>
            <ul className="mt-10 space-y-4">
              {s.itinerariesPoints.map((p, i) => (
                <li
                  key={i}
                  className="flex items-start gap-4 border-b border-white/15 pb-4"
                  data-testid={`itinerary-point-${i}`}
                >
                  <Check className="h-5 w-5 text-[hsl(var(--accent))] mt-1 flex-shrink-0" />
                  <span className="text-white/90">{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
